export default {
    requestAccessToken: data => {
        return {
            type: 'REQUEST_ACCESS_TOKEN',
            data
        };
    },
    receiveAccessToken: data => {
        return {
            type: 'RECEIVE_ACCESS_TOKEN',
            data
        };
    },
    error: data => {
        return {
            type: 'CALL_FAILURE',
            data
        };
    }
};



// WEBPACK FOOTER //
// ./src/actions/apigee.js